<template>
  <div class="user-avatar" :class="sizeClass" :style="sizeStyle">
    <el-upload
      v-if="editable"
      :http-request="uploadImage"
      :auto-upload="true"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :headers="uploadHeaders"
      :on-error="handleUploadError"
    >
      <img class="user-avatar__img" :src="avatarSrc" alt="头像" />
    </el-upload>
    <img v-else class="user-avatar__img" :src="avatarSrc" alt="头像" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import firendsIcon from "@/assets/images/firends.png";
import { useUserStore } from "@/stores/user";
import { useAvatarUpload } from "@/composables/useAvatarUpload.js";

// 仅个人中心/账号管理等处的默认尺寸（页头内头像尺寸由 AppHeader 自己配置）
const PROFILE_AVATAR_SIZE = 56;

// defineProps 为 script setup 的编译器宏，ESLint 需单独允许
/* eslint-disable-next-line no-undef */
const props = defineProps({
  /** 头像尺寸（px），不传则用 PROFILE_AVATAR_SIZE，页头组件里传具体数字即可 */
  size: {
    type: Number,
    default: undefined,
  },
  /** 是否可点击上传 */
  editable: {
    type: Boolean,
    default: false,
  },
  /** 头像地址覆盖（不传则用 store 中的 userInfo.icon） */
  src: {
    type: String,
    default: "",
  },
});

const userStore = useUserStore();
const uploadApi = useAvatarUpload();
const uploadHeaders = uploadApi.uploadHeaders;
const beforeUpload = uploadApi.beforeUpload;
const uploadImage = uploadApi.uploadImage;
const handleUploadError = uploadApi.handleUploadError;

const avatarSrc = computed(() => {
  if (props.src) return props.src;
  return userStore.userInfo?.icon || firendsIcon;
});

const sizePx = computed(() => {
  return props.size ?? PROFILE_AVATAR_SIZE;
});

const sizeClass = computed(() => {
  const px = sizePx.value;
  if (px <= 32) return "user-avatar--small";
  if (px <= 56) return "user-avatar--medium";
  return "";
});

const sizeStyle = computed(() => ({
  width: `${sizePx.value}px`,
  height: `${sizePx.value}px`,
}));
</script>

<style lang="scss" scoped>
.user-avatar {
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  cursor: default;

  &:has(.el-upload) {
    cursor: pointer;
  }
}

.user-avatar__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>
